import { runStringExtender } from "vue-js-extender";
runStringExtender();

import {
  ObjectEx
} from "vue-objectex";
import global_ from '@/core/global'
import {
  getStore
} from '@/config/mUtils'

export const STORAGE_TYPE = {
  LOCAL: 'local',
  SESSION: 'session'
};

class UserManager extends ObjectEx {
  constructor(options, funcExtensions, defineProps) {
    let innerOptions = [];
    if (Object.typeOf(options) === "array") {
      Object.copy(innerOptions, options);
    }

    let innerFuncExtensions = {
      isInRole(roleName) {
        let result = false;
        if (!window.localStorage.getItem("user_role")) {
          return result;
        }
        let roles = window.localStorage.getItem("user_role").split(',');
        roles.forEach(role => {
          if (role == roleName) {
            result = true;
          }
        });
        return result;
      },
      getAttrValue(attrKey, storageType = STORAGE_TYPE.LOCAL) {
        let outValue = null;

        switch (storageType) {
          case STORAGE_TYPE.LOCAL:
            outValue = window.localStorage.getItem(attrKey);
            break;
          case STORAGE_TYPE.SESSION:
            outValue = window.sessionStorage.getItem(attrKey);
            break;
        }
        
        return outValue;
      },
      setAttrValue(attrKey, value, storageType = STORAGE_TYPE.LOCAL) {
        if (!attrKey) return;
        if (typeof value !== 'string') {
          value = JSON.stringify(value);
        }

        switch (storageType) {
          case STORAGE_TYPE.LOCAL:
            window.localStorage.setItem(attrKey, value);
            break;
          case STORAGE_TYPE.SESSION:
            window.sessionStorage.setItem(attrKey, value);
            break;
        }
      }
    };
    if (Object.typeOf(funcExtensions) === "object") {
      Object.copy(innerFuncExtensions, funcExtensions);
    }

    let innerDefineProps = {
      token: {
        get() {
          return this.getAttrValue("auth_token");
        }
      },
      userId: {
        get() {
          let storeValue = this.getAttrValue("user_id");
          return `${storeValue}`.toNumber();
        }
      },
      studentId: {
        get() {
          let storeValue = this.getAttrValue("user_student_id");
          if (!!storeValue)
            storeValue = `${storeValue}`.toNumber();
          return storeValue;
        }
      },
      studentPhone: {
        get() {
          return this.getAttrValue("user_student_phone");
        },
        set(value) {
          this.setAttrValue("user_student_phone", value);
        }
      },
      studentEmail: {
        get() {
          return this.getAttrValue("user_student_email");
        },
        set(value) {
          this.setAttrValue("user_student_email", value);
        }
      },
      studentIsEmailValidated: {
        get() {
          let value = `${this.getAttrValue("user_student_isEmailValidated")}`.toNumber();
          return !!value;
        },
        set(value) {
          this.setAttrValue("user_student_isEmailValidated", value ? 1 : 0);
        }
      },
      isSAStudent: {
        get() {
          let isSAStudent = `${this.getAttrValue("user_student_isSAStudent")}`.toNumber();
          return !!isSAStudent;
        }
      },
      isAdmin: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.admin, "name");
          return this.isInRole(roleName);
        }
      },
      isStudent: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.student, "name");
          return this.isInRole(roleName)
        }
      },
      isTeacher: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.teacher, "name");
          return this.isInRole(roleName);
        }
      },
      //行政销售
      isSales: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.sales, "name");
          return this.isInRole(roleName);
        }
      },
      //行政助理
      isAssistant: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.assistant, "name");
          return this.isInRole(roleName);
        }
      },
      //前台客服
      isReceptionist: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.receptionist, "name");
          return this.isInRole(roleName);
        }
      },
      //行政管理
      isExecutiveManager: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.executiveManager, "name");
          return this.isInRole(roleName);
        }
      },
      //教务助理
      isEducationalAssistant: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.educationalAssistant, "name");
          return this.isInRole(roleName);
        }
      },
      //教务总监
      isAcademicDirector: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.academicDirector, "name");
          return this.isInRole(roleName);
        }
      },
      //财务助理
      isFinancialAssistant: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.financialAssistant, "name");
          return this.isInRole(roleName);
        }
      },
      //财务会计
      isFinancialAccounting: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.financialAccounting, "name");
          return this.isInRole(roleName);
        }
      },
      //财务主管
      isFinancialManager: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.financialManager, "name");
          return this.isInRole(roleName);
        }
      },
      //平台编辑
      isPlatformEditor: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.platformEditor, "name");
          return this.isInRole(roleName);
        }
      },
      //人事主管
      isPersonnelManagement: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.personnelManagement, "name");
          return this.isInRole(roleName);
        }
      },
      isRegionCEO: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.regionCEO, "name");
          return this.isInRole(roleName);
        }
      },
      isCampusPresident: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.campusPresident, "name");
          return this.isInRole(roleName);
        }
      },
      isSABusinessManager: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.saBusinessManager, "name");
          return this.isInRole(roleName);
        }
      },
      isSABusinessSales: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.saBusinessSales, "name");
          return this.isInRole(roleName);
        }
      },
      isSABusinessAssistant: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.saBusinessAssistant, "name");
          return this.isInRole(roleName);
        }
      },
      isSAFinancialManager: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.saFinancialManager, "name");
          return this.isInRole(roleName);
        }
      },
      isSAFinancialAssistant: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.saFinancialAssistant, "name");
          return this.isInRole(roleName);
        }
      },
      isVocationalTrainingManager: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.vocationalTrainingManager, "name");
          return this.isInRole(roleName);
        }
      },
      isInternationalSales: {
        get() {
          let roleName = global_.roleType.getAttrValue(global_.roleType.internationalSales, "name");
          return this.isInRole(roleName);
        }
      },

      teacherId: {
        get() {
          let storeValue = this.getAttrValue("user_teacher_id");
          if (!!storeValue)
            storeValue = `${storeValue}`.toNumber();
          return storeValue;
        }
      },
      //是否为助教
      isAssistantTeacher: {
        get() {
          let isAssistantTeacher = getStore("user_isAssistantTeacher");
          return isAssistantTeacher === "1";
        }
      },

      isManager: {
        get() {
          return this.isExecutiveManager || this.isFinancialManager;
        }
      },
      isFrontDesk: {
        get() {
          return this.isSales || this.isAssistant || this.isExecutiveManager || this.isReceptionist;
        }
      },
      isFinancial: {
        get() {
          return this.isFinancialAssistant || this.isFinancialManager || this.isFinancialAccounting;
        }
      },
      isSABusiness: {
        get() {
          return this.isSABusinessManager || this.isSABusinessSales || this.isSABusinessAssistant;
        }
      },
      isSAFinancial: {
        get() {
          return this.isSAFinancialManager || this.isSAFinancialAssistant;
        }
      },
      isSAManager: {
        get() {
          return this.isSABusinessManager || this.isSAFinancialManager;
        }
      },
      isSAAssistant: {
        get() {
          return this.isSABusinessAssistant || this.isSAFinancialAssistant;
        }
      },
      isSANormal: {
        get() {
          return !this.isAdmin && !this.isSAFinancialManager && !this.isSABusinessManager;
        }
      },
      isAcademicAffairs: {
        get() {
          return this.isAcademicDirector || this.isEducationalAssistant;
        }
      },
      isStudyAbroad: {
        get() {
          return this.isSABusiness || this.isSAFinancial;
        }
      },
      canViewFullPhone:{
        get(){
          return this.isAdmin || this.isStudent || this.isFinancialManager || this.isSABusinessManager || this.isSAFinancialManager;
        }
      }
    };
    if (Object.typeOf(defineProps) === "object") {
      Object.copy(innerDefineProps, defineProps);
    }

    super(innerOptions, innerFuncExtensions, innerDefineProps);
  }
}

export default Object.deepFreeze(new UserManager());



// WEBPACK FOOTER //
// ./src/core/userManager.js